import api from "./axiosConfig"; // Importa la configuración centralizada de axios

// Obtener todos los clientes finales.
//
// (2026-08-02, ítem 31 + bug P2) Reescrito sobre `params` de axios:
//   - BUG CORREGIDO: el query string se armaba a mano y metía un SEGUNDO '?'
//     al añadir request_type (`/api/clients/?page=1&per_page=20?request_type=all`),
//     por lo que el backend recibía `per_page="20?request_type=all"` y el
//     parámetro se perdía (la lista quedaba paginada aunque se pidiera 'all').
//   - BUG CORREGIDO: al filtrar por empresa se perdían page/per_page/request_type.
//   - `empresa_id` es el nombre CORRECTO del filtro por empresa/tercero dueño
//     de los clientes finales y tiene PRIORIDAD en el backend
//     (client_routes.py:107-114). `client_id` se mantiene por compatibilidad.
//   - `search`: búsqueda de texto libre ya soportada por el backend
//     (client_routes.py:163-178).
export const getEndClients = async ({
  page = 1,
  per_page = 20,
  request_type = false,
  client_id = false,
  empresa_id = false,
  search = false,
  activo = null,
} = {}) => {
  try {
    const authData = localStorage.getItem("authData");
    if (authData) {
      const params = { page, per_page };
      if (request_type !== false && request_type != null) params.request_type = request_type;
      // Prioridad: empresa_id (nombre correcto) > client_id (deprecado).
      const owner = (empresa_id !== false && empresa_id != null && empresa_id !== '')
        ? empresa_id
        : ((client_id !== false && client_id != null && client_id !== '') ? client_id : null);
      if (owner != null) params.empresa_id = owner;
      if (search !== false && search != null && String(search).trim() !== '') {
        params.search = String(search).trim();
      }
      if (activo !== null && activo !== undefined) params.activo = String(activo);
      const response = await api.get('/api/clients/', { params });
      return response.data;
    }
  } catch (error) {
    console.error("Error al obtener los final-clients:", error);
    throw error;
  }
};

export const getAuditLogs = async ({ page = 1, per_page = 20 } = {}) => {
    try {
      const response = await api.get(`/admin/logs?page=${page}&per_page=${per_page}`);
      return response.data; // Retorna los datos directamente
    } catch (error) {
      console.error("Error fetching audit logs:", error);
      throw error; // Lanzamos el error para que el componente lo maneje
    }
  };

// Consultar un cliente por ID
export const showEndClient = async (id) => {
  try {
    const authData = localStorage.getItem("authData");
    if (authData) {
      const { rol } = JSON.parse(authData);
      var response;
      /*if (rol == 'admin'){
        response = await api.get(`/admin/clients/${id}`);
      }else{*/
      response = await api.get(`/api/clients/${id}`);
      //}
      return response.data;
    }
  } catch (error) {
    console.error("Error al consultar el cliente:", error);
    throw error;
  }
};

// Editar un cliente
export const editEndClient = async (id, body) => {
  try {
    const authData = localStorage.getItem("authData");
    if (authData) {
      const { rol } = JSON.parse(authData);
      var response;
      /*if (rol == 'admin'){
        response = await api.put(`/admin/clients/${id}`, body);
      }else{*/
      response = await api.put(`/api/clients/${id}`, body);
      //}
      return response.data;
    }
  } catch (error) {
    console.error("Error al editar el cliente:", error);
    throw error;
  }
};

// Crear un cliente
export const createEndClient = async (body) => {
  try {
    const response = await api.post(`/api/clients/`, body);
    console.log('createEndClient-response: ', response);
    return response.data;
  } catch (error) {
    console.error("Error al crear el cliente:", error);
    throw error;
  }
};

// Desactivar un cliente
export const deleteEndClient = async (id) => {
  try {
    const response = await api.delete(`/api/clients/${id}`);
    console.log('deleteEndClient-response: ', response);
    return response.data;
  } catch (error) {
    console.error("Error al eliminar el cliente:", error);
    throw error;
  }
};

// Activar un cliente
export const searchEndClient = async (rif) => {
  try {
    const response = await api.get(`/api/clients/search?rif=${rif}`);
    console.log('searchEndClient-response: ', response);
    return response.data;
  } catch (error) {
    console.error("Error al consultar el cliente:", error);
    throw error;
  }
};

